/**
 * Optimized Visual Coordinates for Jordan Map
 * visualX: 0 (West) to 100 (East)
 * visualY: 0 (North) to 100 (South)
 */
export const jordanGovernorates = [
  { 
    name: 'Irbid', 
    coordinates: [32.5556, 35.8500], 
    visualX: 35, 
    visualY: 8,
    description: 'Northern educational hub.'
  },
  { 
    name: 'Ajloun', 
    coordinates: [32.3323, 35.7517], 
    visualX: 22, 
    visualY: 15,
    description: 'Lush forest highlands.'
  },
  { 
    name: 'Jerash', 
    coordinates: [32.2697, 35.8983], 
    visualX: 45, 
    visualY: 18,
    description: 'Historic Roman ruins.'
  },
  { 
    name: 'Mafraq', 
    coordinates: [32.3426, 36.2071], 
    visualX: 75, 
    visualY: 15,
    description: 'Northern desert gateway.'
  },
  { 
    name: 'Balqa', 
    coordinates: [32.0393, 35.7277], 
    visualX: 20, 
    visualY: 35,
    description: 'Historic city of Salt.'
  },
  { 
    name: 'Amman', 
    coordinates: [31.9454, 35.9284], 
    visualX: 48, 
    visualY: 42,
    description: 'The capital city.'
  },
  { 
    name: 'Zarqa', 
    coordinates: [32.0728, 36.0876], 
    visualX: 72, 
    visualY: 38,
    description: 'Industrial center.'
  },
  { 
    name: 'Madaba', 
    coordinates: [31.7197, 35.7956], 
    visualX: 35, 
    visualY: 55,
    description: 'City of Mosaics.'
  },
  { 
    name: 'Karak', 
    coordinates: [31.1848, 35.7049], 
    visualX: 42, 
    visualY: 72,
    description: 'South fortress city.'
  },
  { 
    name: 'Tafilah', 
    coordinates: [30.8372, 35.6107], 
    visualX: 32, 
    visualY: 82,
    description: 'Nature and history.'
  },
  { 
    name: 'Maan', 
    coordinates: [30.1962, 35.7340], 
    visualX: 65, 
    visualY: 85,
    description: 'Desert majesty.'
  },
  { 
    name: 'Aqaba', 
    coordinates: [29.5320, 35.0063], 
    visualX: 25, 
    visualY: 94,
    description: 'Red Sea port.'
  }
];

export default jordanGovernorates;